// @flow

import { execute }        from 'fg-frontend/src/partialUpdate/partialUpdate';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';
import closeEsp           from 'fg-frontend/webActions/closeEsp';
import goBack             from 'fg-frontend/webActions/goBack';
import scrollToHref       from 'fg-frontend/webActions/scrollToHref';
import confirmPopup       from 'fg-frontend/webActions/confirmPopup';
import passwordStrength   from 'fg-frontend/webActions/passwordStrength';
import toggleClass        from 'fg-frontend/webActions/toggleClass';
import printPage          from 'fg-frontend/webActions/printPage';

import configureEshopActions from './configureEshopActions';
import recall                from './webActions/recall';
import switchClass           from './webActions/switchClass';
import clearInput            from './webActions/clearInput';
import switchAccordion       from './webActions/switchAccordion';

export default (action: string) => {
	switch ( action ) {
		case 'hsExpand':
			return (props?: any, e?: Event) => {
				if (e) e.preventDefault();
				CursorSpinner.pushToQueue('importHsExpand');
				import('./webActions/hsExpand').then((hsExpand) => {
					CursorSpinner.removeFromQueue('importHsExpand');
					hsExpand.default(props, e);
				});
			};
		case 'execute':
			return execute;
		case 'closeEsp':
			return closeEsp;
		case 'goBack':
			return goBack;
		case 'scrollToHref':
			return scrollToHref;
		case 'passwordStrength':
			return passwordStrength;
		case 'confirmPopup':
			return confirmPopup;
		case 'toggleClass':
			return toggleClass;
		case 'switchClass':
			return switchClass;
		case 'printPage':
			return printPage;
		case 'recall':
			return recall;
		case 'clearInput':
			return clearInput;
		case 'switchAccordion':
			return switchAccordion;
		// eslint-disable-next-line no-case-declarations
		default:
			const eshopAction = configureEshopActions(action);
			if ( eshopAction ) return eshopAction;
			// eslint-disable-next-line no-console
			console.log(`Unknown action "${ action }"`);
			return null;
	}
};



// WEBPACK FOOTER //
// ./fe/web-auto/src/js/configureWebActions.js